export const MuiFormControlLabel = {
	styleOverrides: {
		root: {
			marginRight: 'unset',
		},
	},
};
